import clsx from 'clsx';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import style from './Header.module.scss';
export interface HeaderUserProps {}

export default function HeaderUser(props: HeaderUserProps) {
  const [isValueNav, setIsValueNav] = React.useState<number>(
    Number(localStorage.getItem('isValueNavUser'))
  );
  const { t } = useTranslation();
  React.useEffect(() => {
    let newNumber = localStorage.getItem('isValueNavUser');
    setIsValueNav(Number(newNumber));
  }, []);
  const setParamsItemNavbar = (number: number) => {
    setIsValueNav(number);
    localStorage.setItem('isValueNavUser', number.toString());
  };

  return (
    <>
      <Link key={1} to={`/user/home`}>
        <div
          onClick={() => setParamsItemNavbar(1)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 1,
          })}
        >
          {t('content.home')}
        </div>
      </Link>
      <Link key={2} to={`/user/management`}>
        <div
          onClick={() => setParamsItemNavbar(2)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 2,
          })}
        >
          {t('content.management')}
        </div>
      </Link>
      <Link key={3} to={`/user/analysis`}>
        <div
          onClick={() => setParamsItemNavbar(3)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 3,
          })}
        >
          {t('content.analysis')}
        </div>
      </Link>
      <Link key={4} to={`/user/alarm`}>
        <div
          onClick={() => setParamsItemNavbar(4)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 4,
          })}
        >
          {t('content.alarm')}
        </div>
      </Link>
    </>
  );
}
